/*
 * extra cache for setting the current JWT
 * needed because the request.js cannot require the store
 * without creating a recursive dependency
 */
type Hook = () => Promise<string | undefined>;
let currentHook: Hook = async () => undefined;
let ongoing: Promise<string | undefined> | null = null;

export function getToken(): Promise<string | undefined> {
	// console.log('getToken', currentToken && currentToken.length > 0);
	if (ongoing) {
		// console.log('returning ongoing token get');
		return ongoing;
	}
	ongoing = currentHook();
	ongoing.then(() => (ongoing = null));
	return ongoing;
}

export function setTokenHook(t: () => Promise<string | undefined>) {
	// console.log('setToken', !!t);
	currentHook = t;
}
